import React from 'react';
import { Wrapper } from './styles';

interface Props {
  children: React.ReactNode;
}

const Header = (props: Props) => {
  return <Wrapper>{props.children}</Wrapper>;
};

export default Header;
